import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function HighlyEnrolledCourses() {
  const [year, setYear] = useState("2025");

  const dataMap = {
    "2025": [
      { name: "Git", value: 35 },
      { name: "HTML", value: 55 },
      { name: "Nodejs", value: 40 },
      { name: "MySQL", value: 15 },
      { name: "React", value: 25 },
      { name: "Java", value: 45 },
    ],
    "2024": [
      { name: "Git", value: 25 },
      { name: "HTML", value: 45 },
      { name: "Nodejs", value: 35 },
      { name: "MySQL", value: 20 },
      { name: "React", value: 30 },
      { name: "Java", value: 40 },
    ],
    "2023": [
      { name: "Git", value: 20 },
      { name: "HTML", value: 35 },
      { name: "Nodejs", value: 30 },
      { name: "MySQL", value: 10 },
      { name: "React", value: 22 },
      { name: "Java", value: 28 },
    ],
    "2022": [
      { name: "Git", value: 15 },
      { name: "HTML", value: 30 },
      { name: "Nodejs", value: 25 },
      { name: "MySQL", value: 12 },
      { name: "React", value: 18 },
      { name: "Java", value: 20 },
    ],
  };

  const data = dataMap[year];

  return (
    <Card className="h-100"
      style={{
        padding: 20,
        borderRadius:"6px",
                border: "2px solid #eee",
        fontFamily: "Inter, sans-serif",
                
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h6 style={{ fontWeight: 600 }}>
          Highly Enrolled Courses
        </h6>

        <Dropdown>
          <Dropdown.Toggle
            style={{
              background: "#fff",
              border: "1px solid #ddd",
              color: "#111",
              fontSize: 13,
            }}
          >
            {year}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {["2025", "2024", "2023", "2022"].map((y) => (
              <Dropdown.Item key={y} onClick={() => setYear(y)}>
                {y}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* GRAPH */}
      <div style={{ width: "100%", height: 250, marginTop: 20 }}>
        <ResponsiveContainer>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ left: 20 }}
          >
            {/* GRID STYLE (dashed lines) */}
            <XAxis
              type="number"
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />

            <YAxis
              dataKey="name"
              type="category"
              tick={{ fontSize: 13 }}
              axisLine={false}
              tickLine={false}
            />

            {/* TOOLTIP */}
            <Tooltip
              contentStyle={{
                background: "#fff",
                borderRadius: 10,
                border: "1px solid #eee",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                fontSize: 13,
              }}
              formatter={(value) => [`Skill Level: ${value} hrs`, ""]}
            />

            {/* BAR */}
            <Bar
              dataKey="value"
              fill="#f97316"
              radius={[10, 10, 10, 10]}
              barSize={15}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* FOOTER TEXT */}
      <p style={{ fontSize: 13, marginTop: 10 }}>
        <span style={{ color: "#3b82f6" }}>•</span>{" "}
        No of Employees increased by{" "}
        <span style={{ color: "#16a34a" }}>+20%</span> from last Week
      </p>
    </Card>
  );
}